/**
 * Release only voices created by live keyboard/MIDI input. Timeline voices are
 * intentionally absent from these registries and must survive UI lifecycle
 * events such as closing a modal, dragging a control, or changing focus.
 */
export function releaseHeldInputVoices(heldVoices, engines, trackId = null, immediate = true) {
  heldVoices.forEach((voice, key) => {
    if (trackId && voice.trackId !== trackId) return;
    engines.get(voice.trackId)?.noteOff(voice.voiceId, immediate);
    heldVoices.delete(key);
  });
  return [...new Set([...heldVoices.values()].map((voice) => voice.note))];
}

export function releaseArpeggiatorVoices(activeVoices, trackId = null, immediate = false) {
  activeVoices.forEach((voice, voiceId) => {
    if (trackId && voice.trackId !== trackId) return;
    voice.engine?.noteOff(voiceId, immediate);
    activeVoices.delete(voiceId);
  });
}
